import { ALL_USERS_PERMISSION, permissions } from "../shared/utils/permission.constant";
import { GREEN_MATERIALS_MODULE_ID, MATERIAL_VENDORS_MODULE_ID } from "../shared/utils/constant";
import { modulePermissionList, moduleResponsePermissionList } from "../shared/utils/module-access";

export enum AdminRoutes {
  Dashboard = 'dashboard',
  SnSDashboard = 'sns/dashboard',
  Project = 'projects',
  ClientList = 'client-list',
  Reports = 'reports',
  LeaveTracking = 'leave-tracking',
  Profile = 'profile',
  Events = 'events',
  Settings = 'settings',
  Elements = 'elements',
  Sns = 'sns',
  Client = 'client',
  ClientDetail = 'client-detail',
  UserManagement = 'user-management',
  Consultants = 'consultants',
  ClientDashboard = 'client-dashboard',
  Calendar = 'calendar',
  Activities = 'activities',
  GreenMaterial = 'green-material',
  Vendors = 'vendors',
  Enquiries = 'enquiries',
  Tutorial = 'tutorial',
}

// export class AdminRoute {
//   name: string = '';
//   route: string = '';
//   icon: string = '';
//   constructor(name: string, route: string, icon: string) {
//     this.name = name;
//     this.route = route;
//     this.icon = icon;
//   }
// }

export class AdminRoute {
  name: string;
  route: string;
  icon: string;
  children?: AdminRoute[];
  // One permission ({ id }) or a list (shown when any is held)
  permissionId?: any;

  constructor(name: string, route: string, icon: string, children: AdminRoute[] = [], permissionId: any) {
    this.name = name;
    this.route = route;
    this.icon = icon;
    this.children = children;
    this.permissionId = permissionId
  }
}

const permission = permissions;


export const SNSAdminRouteLinks: AdminRoute[] = [
  { name: 'Dashboard', route: 'sns/dashboard', icon: 'bi bi-columns-gap', permissionId: permission.DASHBOARD_VIEW_DASHBOARD },
  { name: 'Projects', route: 'sns/projects', icon: 'bi bi-folder2', permissionId: permission.PROJECT_VIEW_PROJECT_LIST },
  { name: 'Client List', route: 'sns/client-list', icon: 'bi bi-person-vcard', permissionId: permission.CLIENT_LIST_VIEW_CLIENT_LIST },
  { name: 'User Management', route: 'sns/user-management', icon: 'bi bi-person-gear', permissionId: permission.USER_MANAGEMENT_VIEW_USER_LIST },
  { name: 'Consultants', route: 'sns/consultants', icon: 'bi bi-people', permissionId: permission.CONSULTANTS_VIEW_CONSULTANTS },
  // { name: 'Calendar', route: 'sns/calendar', icon: 'bi bi-calendar-event', permissionId: permission.CALENDAR_VIEW_CALENDAR },
  { name: 'Calendar', route: 'sns/calendar', icon: 'bi bi-calendar-event', permissionId: permission.CALENDAR_VIEW_CALENDAR },
  { name: 'User Activity Logs', route: 'sns/user-activity-logs', icon: 'bi bi-list-task', permissionId: permission.USER_ACTIVITY_VIEW_USER_ACTIVITY },
  { name: 'Material Vendors', route: 'sns/vendors', icon: 'bi bi-shop', permissionId: modulePermissionList(MATERIAL_VENDORS_MODULE_ID) },
  { name: 'Green Materials', route: 'sns/green-material', icon: 'bi bi-tree', permissionId: modulePermissionList(GREEN_MATERIALS_MODULE_ID) },
  // No permissionId → Super Admin only, matching the backend (context-responses is Super Admin only)
  { name: 'Enquiries', route: 'sns/enquiries', icon: 'bi bi-inbox' },
  { name: 'Profile', route: 'sns/profile', icon: 'bi bi-person', permissionId: permission.PROFILE_VIEW_PROFILE },
  { name: 'Tutorial', route: 'sns/tutorial', icon: 'bi bi-play-btn', permissionId: ALL_USERS_PERMISSION },
  // All Forms stays Super Admin only; Responses opens to roles that review a record module's responses
  {
    name: 'Forms', route: 'sns/forms', icon: 'bi bi-ui-checks', permissionId: moduleResponsePermissionList(), children: [
      { name: 'All Forms', route: 'sns/forms', icon: 'bi-dot' },
      { name: 'Responses', route: 'sns/forms/responses', icon: 'bi-dot', permissionId: moduleResponsePermissionList() },
    ]
  },
  {
    name: 'Master', route: 'sns/master', icon: 'bi bi-gear', permissionId: permission.MASTER, children: [
      { name: 'Role Management', route: 'sns/master/roles', icon: 'bi-dot' },
      { name: 'Certification', route: 'sns/master/certification', icon: 'bi-dot', permissionId: permission.CERTIFICATION_MASTER_VIEW_LIST },
      { name: 'Typology', route: 'sns/master/typology', icon: 'bi-dot', permissionId: permission.TYPOLOGY_VIEW_LIST },
      { name: 'Sub Category', route: 'sns/master/sub-category', icon: 'bi-dot', permissionId: permission.SUB_CATEGORY_VIEW_LIST },
      { name: 'Category One', route: 'sns/master/category-one', icon: 'bi-dot', permissionId: permission.CATEGORY_ONE_VIEW_LIST },
      { name: 'Category Docs', route: 'sns/master/category-document', icon: 'bi-dot', permissionId: permission.CATEGORY_DOCUMENTS_VIEW_LIST },
      { name: 'Pre-Cert Input Checklist', route: 'sns/master/input-checklist', icon: 'bi-dot', permissionId: permission.INPUT_CHECKLIST_VIEW_LIST },
      { name: 'Cert Input Checklist', route: 'sns/master/cert-input-checklist', icon: 'bi-dot', permissionId: permission.INPUT_CHECKLIST_VIEW_LIST },
      { name: 'Category', route: 'sns/master/category', icon: 'bi-dot', permissionId: permission.CATEGORY_VIEW_LIST },
      { name: 'Service Level', route: 'sns/master/service-level', icon: 'bi-dot', permissionId: permission.SERVICE_LEVEL_VIEW_LIST },
      { name: 'Unit Master', route: 'sns/master/unit-master', icon: 'bi-dot', permissionId: permission.UNIT_MASTER_VIEW_LIST },
      { name: 'Credit Checklist Category', route: 'sns/master/project-info-category', icon: 'bi-dot' },
      { name: 'Credit Input Checklist', route: 'sns/master/project-info-input-checklist', icon: 'bi-dot' },
      { name: 'Feasibility', route: 'sns/master/feasibility', icon: 'bi-dot' },
    ]
  }
];

export const ClientRouteLinks: AdminRoute[] = [
  { name: 'Dashboard', route: 'client/client-dashboard', icon: 'bi bi-columns-gap', permissionId: permission.DASHBOARD_VIEW_DASHBOARD },
  { name: 'Projects', route: 'client/projects', icon: 'bi bi-folder2', permissionId: permission.PROJECT_VIEW_PROJECT_LIST },
  { name: 'Consultants', route: 'client/consultants', icon: 'bi bi-people', permissionId: permission.CONSULTANTS_VIEW_CONSULTANTS },
  // { name: 'Client List', route: 'client/client-list', icon: 'bi bi-person-vcard', permissionId: permission.CLIENT_LIST_VIEW_CLIENT_LIST },
  { name: 'Calendar', route: 'client/calendar', icon: 'bi bi-calendar-event', permissionId: permission.CALENDAR_VIEW_CALENDAR },
  { name: 'Material Vendors', route: 'client/vendors', icon: 'bi bi-shop', permissionId: modulePermissionList(MATERIAL_VENDORS_MODULE_ID) },
  { name: 'Green Materials', route: 'client/green-material', icon: 'bi bi-tree', permissionId: modulePermissionList(GREEN_MATERIALS_MODULE_ID) },
  {
    name: 'Forms', route: 'client/forms', icon: 'bi bi-ui-checks', permissionId: moduleResponsePermissionList(), children: [
      { name: 'Responses', route: 'client/forms/responses', icon: 'bi-dot', permissionId: moduleResponsePermissionList() },
    ]
  },
  { name: 'Tutorial', route: 'client/tutorial', icon: 'bi bi-play-btn', permissionId: ALL_USERS_PERMISSION },
  { name: 'Profile', route: 'client/profile', icon: 'bi bi-gear', permissionId: permission.PROFILE_VIEW_PROFILE },
]

export enum ElementRoutes {
  Alert = 'alert',
  Modal = 'modal',
  Buttons = 'buttons',
  Tabs = 'tabs',
  DataTable = 'data-table',
  Forms = 'forms',
}

export enum SettingRoutes {
  Profile = 'profile',
  Users = 'users',
}

export enum ComplianceRoutes {
  ProjectDetails = 'project-detail',
  ComplianceDetails = 'compliance-detail'
}
